(() => {
  const swiperWrappers = document.querySelectorAll(".swiper-wrapper");

  if (swiperWrappers.length > 0) {
    swiperWrappers.forEach((swiperWrapper) => {
      const swiperElement = swiperWrapper.querySelector("swiper-container");

      if (!swiperElement || swiperWrapper.dataset.dontCustomize == "true") {
        return;
      }

      swiperElement.addEventListener("swiperafterinit", () => {
        const swiperSlides = swiperWrapper.querySelectorAll(".swiper-slide");

        positionButtons(swiperWrapper);

        if (swiperSlides.length <= 3) {
          swiperSlides.forEach((slide, index) => {
            const cloneSlide = slide.cloneNode(true);
            cloneSlide.classList.add("swiper-slide--clone");
            swiperElement.appendChild(cloneSlide);
          });
        }
      });

      swiperElement.addEventListener("swiperupdate", () => {
        const swiperBullets = swiperWrapper.querySelectorAll(
          ".swiper-pagination-bullet"
        );

        const limit = parseInt(swiperWrapper.dataset.limit);

        positionButtons(swiperWrapper);

        if (swiperBullets.length >= limit) {
          swiperBullets.forEach((bullet, index) => {
            if (index >= limit) {
              bullet.remove();
            }
          });
        }
      });

      swiperElement.addEventListener("swiperbreakpoint", () => {
        positionButtons(swiperWrapper);
      });
    });
  }

  function positionButtons(swiperWrapper) {
    const swiperImage = swiperWrapper.querySelector(".swiper-image");
    const swiperButtons = swiperWrapper.querySelector(".swiper-buttons");

    if (swiperButtons) {
      if (swiperImage && window.matchMedia("(max-width: 1023px)").matches) {
        const swiperImageHeight = swiperImage.offsetHeight;

        swiperButtons.style.top = swiperImageHeight / 2 + "px";
      } else {
        swiperButtons.style.top = null;
      }
    }
  }
})();
